import { userActivityApi } from '../api';

export const userActivityRepo = {
    getAll: (params) => userActivityApi.getAll(params),
    getStats: (params) => userActivityApi.getStats(params),
    getByUser: (userlogId, params) => userActivityApi.getByUser(userlogId, params),
    getBySubject: (subjectId, params) => userActivityApi.getBySubject(subjectId, params),
    getById: (activityId) => userActivityApi.getById(activityId),
};